<template>
  <page-header-bar>
    <div v-if="!loading" class="review-title" data-cy="review-title">
      {{ review.title }}
    </div>
    <v-skeleton-loader v-else width="400" type="text" />
    <template v-if="!loading" #actions>
      <div class="d-flex align-center">
        <action-button
          color="primary"
          class="mr-3"
          height="36"
          @click="$emit('upload')"
        >
          <v-icon left class="material-icons-outlined">
            cloud_upload
          </v-icon>
          Upload References
        </action-button>
        <action-button
          color="success"
          class="mr-3"
          :disabled="disableDownload"
          @click="$emit('download-references')"
        >
          <v-icon left class="material-icons-outlined">
            download
          </v-icon>
          Download References
        </action-button>
        <action-button
          color="accent"
          class="mr-3"
          :disabled="disableDownload"
          @click="$emit('export-review')"
        >
          <v-icon left class="material-icons-outlined">
            system_update_alt
          </v-icon>
          Export
        </action-button>
        <action-button
          color="accent"
          class="mr-3"
          @click="$emit('show-prisma-stats')"
        >
          <v-icon left class="material-icons-outlined">
            assessment
          </v-icon>
          PRISMA
        </action-button>
        <settings-button :to="`/review/${review.id}/settings`" />
      </div>
    </template>
  </page-header-bar>
</template>

<script>
import PageHeaderBar from '@/components/Common/PageHeaderBar';
import ActionButton from '@/components/Common/ActionButton';
import SettingsButton from '@/components/Common/SettingsButton';
import { Review } from '@/models';

export default {
  name: 'ReviewPageHeader',
  components: {
    PageHeaderBar,
    ActionButton,
    SettingsButton,
  },
  props: {
    review: {
      type: Review,
      default: () => null,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    disableDownload: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.review-title {
  // This hack makes sure the text ellipsis works on overflow.
  display: contents;
}
</style>
